import { Container, Layout, Text } from "@certn/cascadia-react";
import { Trans } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { useStyles } from "./styles";
import { AppFooter } from "../../components/app-footer";
import { AppHeader } from "../../components/app-header";

export function CredentialRequestDeclined() {
  const [searchParams] = useSearchParams();
  const clientName = searchParams.get("client_name");
  const styles = useStyles();

  return (
    <Layout
      layout="auth"
      header={<AppHeader hideSettings showLoginButton />}
      footer={<AppFooter />}
    >
      <Container>
        <div className={styles.container}>
          <Text as="h2" style="form/page-title">
            <Trans>Request declined</Trans>
          </Text>
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>
                You have declined your credential request from {{ clientName }},
                and can close this window.
              </Trans>
            </Text>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
